export default __webpack_public_path__ + "static/media/white oreo full.dbe86b71.png";